var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "filter-section" },
    [
      _c("h5", [_vm._v(_vm._s(_vm.title))]),
      _c(
        "md-field",
        [
          _c(
            "md-select",
            {
              attrs: { name: _vm.id, id: _vm.id },
              model: {
                value: _vm.selectedValue,
                callback: function ($$v) {
                  _vm.selectedValue = $$v
                },
                expression: "selectedValue",
              },
            },
            [
              _c("md-option", { attrs: { value: "All" } }, [_vm._v("All")]),
              _vm._l(_vm.options, function (option) {
                return _c(
                  "md-option",
                  { key: option.id, attrs: { value: option.id } },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(option.label) +
                        "\n            "
                    ),
                  ]
                )
              }),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }